import { IconProps } from "./types";

export const CheckboxIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M14 16.6309H2C0.9 16.6309 0 15.7309 0 14.6309V2.63086C0 1.53086 0.9 0.630859 2 0.630859H14C15.1 0.630859 16 1.53086 16 2.63086V14.6309C16 15.7309 15.1 16.6309 14 16.6309ZM7.12 12.2809L13.01 6.39086C13.4 6.00086 13.4 5.37086 13.01 4.98086C12.62 4.59086 11.99 4.59086 11.6 4.98086L6.42 10.1609L4.4 8.14086C4.01 7.75086 3.38 7.75086 2.99 8.14086C2.6 8.53086 2.6 9.16086 2.99 9.55086L5.72 12.2809C5.91 12.4709 6.16 12.5709 6.43 12.5709C6.7 12.5709 6.95 12.4609 7.14 12.2809H7.12Z"
        fill={fillColor ?? "#E6E6E6"}
      />
      <path
        d="M13.0156 6.39195L7.12562 12.282H7.14562C6.95562 12.462 6.70563 12.572 6.43562 12.572C6.16562 12.572 5.91562 12.472 5.72562 12.282L2.99562 9.55195C2.60563 9.16195 2.60563 8.53195 2.99562 8.14195C3.38563 7.75195 4.01563 7.75195 4.40563 8.14195L6.42563 10.162L11.6056 4.98195C11.9956 4.59195 12.6256 4.59195 13.0156 4.98195C13.4056 5.37195 13.4056 6.00195 13.0156 6.39195Z"
        fill="white"
      />
    </svg>
  );
};
